<template>
  <div class="infooverlay" @click="updateMapLabel">
    <transition name="fade-fast" mode="out-in">
    <div class="text" :key="text">{{ text }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'infooverlay',
  methods: {
    updateMapLabel() {
      this.$emit('updateMapLabel');
    },
  },
  props: {
    text: String,
  },
};
</script>

<style scoped lang="scss">

.infooverlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(210,83,68,.3);
  display: grid;
  justify-items: center;
  align-items: center;


  .text {
    position: absolute;
    border: 1px solid $color-brand;
    box-shadow: 1px 1px 3px $color-black;
    background-color: $color-bg;
    font-size: 12px;
    width: 60%;
    height: auto;
    padding: $padding-default/2;
  }

}
</style>
